module.exports = __webpack_public_path__ + "se.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/se.svg
// module id = 796
// module chunks = 0